
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/step-button",
      function () {
        return require("private-next-pages/joy-ui/api/step-button.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/step-button"])
      });
    }
  